var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFlame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 93,
    viewBox: "0 0 66 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1473 72.0388C21.1436 69.3142 19.67 65.2359 19.7214 60.2494C12.0617 68.2176 12.4387 81.395 20.8523 92.379C13.2955 89.3631 8.1376 84.5823 4.6419 78.0878C-1.42417 66.7782 -0.961515 55.3657 5.27591 44.3303C7.86342 39.755 11.2049 35.5568 14.4778 31.4099C21.5549 22.4479 26.0273 12.5948 25.7531 0.942474C25.7531 0.634029 25.9417 0.32558 26.0445 0C39.6332 5.65481 47.7212 19.2949 51.3712 41.6057C53.1362 38.5555 54.884 35.5054 56.7175 32.3524C60.7273 38.5384 63.4861 45.7012 65.0626 53.3437C68.6783 70.7537 60.7616 86.4329 45.0995 92.6189C46.7959 90.357 48.698 88.4207 49.9146 86.1073C53.5645 79.253 52.8962 72.3816 49.0578 65.8186C47.6013 63.3339 45.8192 61.0377 44.0371 58.7586C40.0273 53.6007 37.4398 47.8945 37.1313 40.5604C27.1754 49.1283 25.0506 59.7182 26.1473 72.0388Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlame);
export default __webpack_public_path__ + "static/media/icon-flame.bd16350cd79621c828e80bb79cdf40f6.svg";
export { ForwardRef as ReactComponent };